import { ReturnRewardsMethod } from "@/api/workFlow/type"
import { IColumnConfig } from "@/pages/Management/components/ManagementTable/types"

import { IBase } from "./IBase"

export interface Item {
  id: IColumnConfig[0]["id"]
  label: string
}

export interface IManagement extends IBase {
  tableColumnSelected?: string[]
  tableColumnChoices?: Item[]
}

export interface ICustomChoices {
  label: string
  value: string
  id?: string
}

export enum IReturnStatus {
  PendingReview = 1,
  Approved = 2,
  Resolved = 3,
  Rejected = 4,
  Archived = 5,
}

export enum IReturnStatusMap {
  Pending_review = "default",
  Approved = "info",
  Resolved = "success",
  Rejected = "critical",
}

export enum ActionButton {
  Approved = "approved",
  Exchange = "exchanged",
  Refund = "refunded",
  Received = "received",
  Resolved = "resolved",
  Rejected = "rejected",
  Restock = "restock",
  exchanged_diff = "exchanged_diff",
}

export enum MoreAction {
  Received = "received",
  Restock = "restock",
}

export enum IProcessStatus {
  Refunded = "Refunded",
  Received = "Received",
  Restocked = "Restocked",
  Refund_failed = "Refund failed",
  Exchanged = "Exchanged",
  Refund_Processing = "Refund processing",
  Partially_Received = "Partially received",
  Partially_Restocked = "Partially restocked",
  Pending_Refund = "Pending refund",
  Pending_Exchange = "Pending exchange",
}

export enum IProcessProgress {
  Incomplete = "incomplete",
  PartiallyComplete = "partiallyComplete",
  Complete = "complete",
}

/** 换货状态 -1 未同意(不存在换货状态) 0-等待换货 1-已换货 */
export enum IExchangeProcessStatus {
  NotAgreed = -1,
  PendingExchange = 0,
  Exchanged = 1,
}

/** 退款状态 -1 无状态 0-等待退款 1-退款中 2-退款失败 3-退款成功 */
export enum IRefundProcessStatus {
  NoStatus = -1,
  PendingRefund = 0,
  Processing = 1,
  Failed = 2,
  Success = 3,
}

/** label 创建展示状态 -1 无 0 待处理 1 处理中 2 已完成 3 失败 */
export enum LogisticsState {
  None = -1,
  Pending = 0,
  Processing = 1,
  Completed = 2,
  Failed = 3,
}

/** 物流标签异步任务 Banner 状态 1 显示 2 已关闭 */
export enum LabelAsyncBannerState {
  Show = 1,
  Closed = 2,
}

export interface IProcessStatusConfig {
  process_status: IProcessStatus
  request_id?: number
}

export interface IOrderNoProps {
  order_no: string
  rma: string
}

export interface customerInfoProps {
  customer_email: string
  customer_name: string
  customer_phone: string
}

export interface IReturnItems {
  key: string
  itemsLength: string
  orderNO: IOrderNoProps
  processStatus: IProcessStatusConfig[]
  returnStatus: IReturnStatus
  solution: string
  requestDate: string
  image: string
  shippingStatus: number
  successFlowRunId: number
  shipping_method_id: number
  customerInfo: customerInfoProps
}

export interface ISolutionItem {
  id: number
  name: string
  extra_fields?: {
    enabled: boolean
    label: string
    key: string
  }[]
}

export interface IDisplayItem {
  net_weight: number
  mass_unit: string
  return_product_id: number
  hs_code: string
  origin_country: string
}

export interface ICustomerInfo {
  account_number: string
  account_holder_name: string
  bank_identifier: string
  account_number_title?: string
  account_holder_name_title?: string
  bank_identifier_title?: string
  customer_id: string | number
  customer_name: string
  customer_email: string
  customer_phone: string
  wise_iban: string
  wise_name: string
}

export interface ProductItem {
  shopify_variant_id: number
  exchange_product_item?: {
    id: number
    price: number
    quantity: number
    variant_name: string
    product_name: string
    sub_price: number
  }
  order_product: {
    line_item_id: number
    id: number
    shopify_variant_id: number
    variant: {
      product: {
        image: string
        name: string
        shopify_product_id: number
      }
      shopify_product_id: number
      shopify_variant_id: number
      sku: string
      variant_name: string
      image: string
      id: number
      weight: string
      show_weight: string
      total_weight: number
      weight_unit: string
      price: number
    }
  }
  order_product_id: number
  quantity: number
  no_received_quantity: number
  request_id: number
  id: number
  returnReasonNote: string
  money: string
  reason_description: string
  exchange_order_name: string
  provide_proof: string[]
  received_quantity: number
  sub_price: number
}

export interface Action {
  /**
   * 可操作的按钮
   */
  doing: ActionButton[]
  /**
   * 最后一次处置状态
   */
  doStatus: string
  /**
   * 可展示的变量名
   */
  show: string[]
  status: string
  is_show_notify: boolean
  is_show_reject: boolean
  can_handle_req: number
  more_action: MoreAction[]
  is_archived: boolean
}

export enum ReturnTypeEnum {
  return = 1,
  exchange = 2,
}

export type IExchangeOrderLineItem = {
  id: number
  kind: number
  exchange_id: number
  shop_id: number
  request_id: number
  shopify_product_id: number
  shopify_variant_id: number
  product_name: string
  quantity: number
  price: string
  image: string
  created_at: number
  updated_at: number
  variant_name: string
  shopify_refund?: string
  remain_credit_after_shop?: number
  remain_credit?: string
  check_sku: boolean
  shopify_order_id: number
  line_item_id: number
  sku: string
  sub_price: number
}

type Itracking = {
  tracking_number: string
  shipping_carrier: string
  return_label: string
  return_label_file: any
  is_label_url: number
  return_label_link?: string
  shipping_status?: number
  is_tracking?: number
  carrier_code?: string
  return_shipment_proof?: string[]
  invoice_url?: string
}

export type IReturnFromAddress = {
  address1: string
  address2: string
  city: string
  company?: string
  country: string
  country_code: string
  first_name: string
  last_name: string
  latitude: number
  longitude: number
  name: string
  phone?: string
  province: string
  province_code: string
  zip: string
  full_address: string
}

export type IExchangeOrderInfo = {
  show_origin_discount?: 0 | 1
  draft_order_id?: number
  total_line_items_price?: string
  discount_amount?: string
  remain_credit?: string
  total_price?: string
  order_id?: number
  order_name?: string
  origin_tax_rate?: number
  exchange_estimate_tax_rate?: number
  line_items?: IExchangeOrderLineItem[]
  shopify_refund?: string
  exchange_count: number
  exchange_total?: number
  tax_present?: number
  tax_rate: number
  origin_subtotal: number
  origin_tax?: number
  origin_discount: number
  total_price_set?: {
    presentmentMoney: {
      amount: string
      currencyCode: string
    }
    shopMoney: {
      amount: string
      currencyCode: string
    }
  }
  tax_estimate: string
  exchange_order_currency_symbol?: string
  taxes_included?: number
  remain_credit_after_shop: number
  exchange_credit?: string
}

export enum FixedPercentKind {
  Fixed = 1,
  Percentage = 2,
}

export enum LabelFeeKind {
  NoFee = 1,
  Fixed = 2,
  BasedOnActuals = 3,
}

export interface IRewardsGiftInfo {
  gift_balance: number
  gift_card_used: boolean
  gift_balance_plain: number
  initial_value_plain: number
  gift_card_currency: string
}

export interface IOrderDetailInfo {
  success_flow_run_kind: number[]
  currency: string
  currency_format: string
  customer_info: ICustomerInfo
  customer_id: number
  is_label_url?: number // 0 pdf 1 是地址
  plain_fee_value: number // 物流费
  is_tracking?: number
  return_label_link?: string
  return_shipment_proof?: string[] // C端状态页上传的数组
  exchange_order_id: number // 换货订单id
  carrier_code: string // 运输商查询参数
  discount: number
  taxes_included: number // 0 不包含税 1 包含税
  tags: string[] // 标签数组
  return_fee?: number
  return_rewards?: number
  return_moneys: {
    adjust_val: number
    return_fee_kind: FixedPercentKind
    return_rewards_kind: FixedPercentKind
    adjust_val_kind: FixedPercentKind
    shipping_line_title?: string
  }
  /** 退货奖励方式：0 无；其余见 {@link ReturnRewardsMethod} */
  return_rewards_method?: ReturnRewardsMethod | 0
  return_rewards_shop_amount?: number
  label_fee: number
  all_weight: number // 包裹总重量
  weight_unit: string //  重量单位
  has_many: boolean
  return_from_address?: IReturnFromAddress
  discounts?: {
    discount_code: string
  } | null
  id: number
  max_refund: number
  order_no: string
  order_record_id: number
  refund: number
  real_money: number // 实际退款
  request_date: number
  rma: string
  shipping_carrier: string
  shipping_method_id: number
  shipping_method_text: string
  solution_id: number
  solution_text: string
  status: IReturnStatus
  tax: number
  /** 税率，百分比形式不带百分号 */
  tax_rate: number
  total: number
  tracking_number: string
  no_received_quantity: number
  no_restocked_quantity: number
  total_quantity: number
  decline_reason?: string
  has_use_integration: boolean
  type: ReturnTypeEnum // 1 退货 2 换货
  exchange_order_name: string // 换货号
  shopify_order_id?: number
  shopify_return_id?: number
  shopify_return_name?: string
  return_label?: string // pdf下载地址
  is_select_shipping_method_later: number // 是否选中稍后再选择method
  gift_card?: {
    code: string
    initial_value: string
    request_id: number
  }
  shipping_status: number // 运输状态
  success_flow_run_id: number
  shopify_order_url: string // 订单详情页链接
  invoice_url?: string // 发票打印链接
  rewards_code: string // rewards 相关code
  is_refund: number // 0： 未同意订单 pedding 1： 同意订单
  refund_shipping_type: number // 是否退运费，1: 不退 2: 全退
  refund_status_text: string
  is_test_mode: boolean // 是否测试模式
  label_fee_kind: number // 1-无物流费 2-固定费用 3-按实际扣费
  estimate_label_fee: boolean // label_fee 是否为预估值
  gift_balance: number // 礼品卡余额
  gift_card_used: boolean // 礼品卡是否已使用
  rewards_gift_info: IRewardsGiftInfo
  total_shipping_cost: number // shipping cost 值
  return_address: {
    zip: string
    city: string
    name: string | null
    email: string
    phone: string
    address: string
    country: string
    province: string
    address_detail: string
    address_name?: string
    full_address: string
  }
  pickup: {
    address: {
      address1: string
      address2: string
      apartment?: string
      city: string
      country: string
      country_code: string
      email?: string
      first_name: string
      full_address: string
      last_name: string
      latitude: number
      longitude: number
      name: string
      phone: string
      province: string
      province_code: string
      zip: string
    }
    carrier: string
    code: string
    date: string
    status: string
    time: string
    timezone: string
  }
  exchange_order: IExchangeOrderInfo
  remain_credit_after_shop?: string
  refund_process_status: IRefundProcessStatus
  exchange_process_status: IExchangeProcessStatus
  need_create_exchange_order: number
  return_label_file?: {
    type: string
    size: number
    name: string
  }
  tracking: Itracking[]
  show_pp_conn: boolean // true: pp 集成未连接 false: pp 集成已连接
  line_label_fee: string
  line_return_fee: string
  exchange_from_order_id: number
  exchange_from_order_name: string
  archive_status?: number // 归档状态 0-未归档 1-已归档
  shipping_amount: {
    money: number
    tax: number
    max?: number
  }
  work_flow_refresh: {
    apply: boolean
    continue: boolean
  }
  /** label 创建展示状态，见 {@link LogisticsState} */
  logistics_state?: LogisticsState
  /** 物流标签异步任务 Banner 状态，见 {@link LabelAsyncBannerState} */
  banner_state?: LabelAsyncBannerState
}

export interface ShowModalGroup {
  rejected_modal_show: boolean
  resolved_modal_show: boolean
  received_modal_show: boolean
  approved_modal_show: boolean
  approved_drawer_show: boolean
  refund_modal_show: boolean
  restock_modal_show: boolean
  exchange_modal_show: boolean
  carrier_service_modal_show: boolean
}

export interface ShowChildModalGroup {
  showShippoModal: boolean
  showSendcloudModal: boolean
  showFedexModal: boolean
  showShipStationModal: boolean
  showDHLModal: boolean
}

export interface timeLineInfoProps {
  id: number
  shop_id: number
  request_id: number
  title: string
  opt: number
  created_at: number
  updated_at: number
  // 操作 0-无 1-跳到tracking detail 2-工作流标识 3-手动备注
  opt_kind: number
  return_product_item: {
    id: number
    /**
     * 商品名称
     */
    product_name: string
    /**
     * 数量
     */
    quantity: number
    /**
     * SKU
     */
    sku: string
    /**
     * 变体名称
     */
    variant_name: string
  }[]
}
